import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { ProfessionalFilterSidebar } from './ProfessionalFilterSidebar';
import { ProfessionalFilters } from '@/types/professional';

interface ProfessionalFilterDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filters: ProfessionalFilters;
  onFiltersApply: (filters: ProfessionalFilters) => void;
  onFiltersReset: () => void;
}

export function ProfessionalFilterDrawer({ 
  open, 
  onOpenChange, 
  filters, 
  onFiltersApply, 
  onFiltersReset 
}: ProfessionalFilterDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-lg p-0 overflow-y-auto">
        <SheetHeader className="p-6 pb-4 border-b">
          <SheetTitle>Filter Professionals</SheetTitle>
          <SheetDescription>
            Find the right professional for your specific needs.
          </SheetDescription>
        </SheetHeader>
        
        <div className="p-6 pb-24">
          <ProfessionalFilterSidebar
            filters={filters}
            onFiltersChange={onFiltersApply}
            onFiltersReset={onFiltersReset}
          />
        </div>

        {/* Sticky bottom actions */}
        <div className="sticky bottom-0 bg-white border-t p-4 flex gap-3">
          <Button 
            variant="ghost" 
            onClick={onFiltersReset}
            className="flex-1"
          >
            Reset
          </Button>
          <Button 
            className="flex-1 bg-st_light_blue hover:bg-st_light_blue/90" 
            onClick={() => onOpenChange(false)}
          >
            Apply
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}